<template>
  <transition :name="name">
    <slot />
  </transition>
</template>

<script>
export default {
  name: 'KwTransition',
  props: {
    name: {
      type: String,
      default: 'appear-y',
    },
  },
};
</script>

<style lang="scss">
  .appear-y-enter {
    transform: translateY(-100%);
  }
  .appear-y-leave {
    transform: translateY(0px);
  }
  .appear-y-leave-to {
    transform: translateY(-100%);
  }

  .appear-x-enter,
  .appear-x-leave-to {
    transform: translateX(100%);
  }
  .appear-x-leave {
    transform: translateX(0px);
  }
  .appear-x-enter-active, .appear-x-leave-active {
    transition: transform .3s ease-out;
  }
</style>



// WEBPACK FOOTER //
// src/components/KwTransition.vue